// import React from "react";
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

function Address({ propertyDetail, propertyPhotos }) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleWindowResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);

    // Cleanup on component unmount
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  const settings = {
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: windowWidth > 900 ? 4 : 3, // Change the breakpoint as needed
    slidesToScroll: 1,
    centerMode: false,
  };

  // const settings = {
  //   dots: false,
  //   infinite: false,
  //   speed: 1000,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   centerMode: false,
  // };

  return (
    <div className="details mx-2">
      <img src={require("../../../assets/images/address-icon.svg").default} />{" "}
      {propertyDetail && (
        <>
          {propertyDetail.address1}
          {propertyDetail.property_type !== "Spaces" && propertyDetail.property_unit_name
            ? ` #${propertyDetail.property_unit_name}`
            : ""}
          {propertyDetail.city && `, ${propertyDetail.city}`}
          {propertyDetail.state && `, ${propertyDetail.state}`}
          {propertyDetail.zipcode && ` ${propertyDetail.zipcode}`}
          {/* Introduced space within address fields and changed conditional rule to allow units*/}
        </>
      )}
      <div className="mt-3">
        <Slider className="property-imgs" {...settings}>
          {propertyPhotos.map((item, index) => (
            <div className="img" key={index} style={{ width: "auto" }}>
              <img className="propertyImage" src={item} alt="" />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default Address;
